module.exports = __webpack_public_path__ + "static/img/13.fbc35e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/13.jpg
// module id = J/zW
// module chunks = 0